module.exports = __webpack_public_path__ + "static/FaroWeb-DisplayLucky-3090a1c15fd75d68b34b3efa25c9e079.woff";